export default __webpack_public_path__ + "static/media/oscer-pres-pr-bleeding.0e910a1e.svg";